export default __webpack_public_path__ + "static/media/creating.446449d0.svg";